// extracted by mini-css-extract-plugin
export var boldCellText = "ec58091a27762da54f1eda77899fca83-css";